import { GetPremiumCTA } from 'components/PremiumCTA/GetPremiumCTA';

import './ModuleLibrary.scss';
import { ModuleCard } from 'components/ModuleCard/ModuleCard';
import { useServices } from 'index';
import { useQuery } from '@tanstack/react-query';
import { ModuleOverview } from 'types/module';
import { ModuleLoaderCard } from 'components/ModuleCard/ModuleLoaderCard/ModuleLoaderCard';

export const ModuleLibrary = () => {
  const service = useServices().learningHubService;
  const { data, isPending } = useQuery({ queryKey: ['learningHubModuleList'], queryFn: service.getModules, refetchOnWindowFocus: false });

  return (
    <div className='modules-tab'>
      <GetPremiumCTA />
      <ModulesGrid modules={data} isPending={isPending} />
    </div>
  );
};

type ModulesGridProps = {
  modules: ModuleOverview[] | undefined;
  isPending: boolean;
};
const ModulesGrid = ({ modules, isPending }: ModulesGridProps) => {
  return (
    <div className='modules-grid'>
      {!isPending
        ? modules?.map((module) => <ModuleCard key={module.id} module={module} />)
        : Array.from(Array(10)).map((el, index) => <ModuleLoaderCard key={index} />)}
    </div>
  );
};
